const TRANSITION_DELAY = 3000;

export default TRANSITION_DELAY;
